import BodyView from "@/layout/BodyView.vue";
import WarehouseStock from "@/pages/warehouse/stockin/Index.vue";
import WaybillGenerade from "@/pages/warehouse/waybill-generade/Index.vue";
import Delivery from "@/pages/warehouse/delivery/Index.vue";
import Return from "@/pages/warehouse/return/Index.vue";

export const route = 
{
  path: "/warehouse",
  component: BodyView,
  children: [
    {
      path: "waybill-generade",
      name: "waybill-generade",
      component: WaybillGenerade,
      meta: {
        title: 'Waybill Generade | INDOFORCETECH',
      }
    },
    {
      path: "delivery",
      name: "delivery",
      component: Delivery,
      meta: {
        title: 'Delivery | INDOFORCETECH',
      }
    },
    {
      path: "return",
      name: "return",
      component: Return,
      meta: {
        title: 'Return | INDOFORCETECH',
      }
    },
    {
      path: "stockin",
      name: "stock In",
      component: WarehouseStock,
      meta: {
        title: 'Warehouse Stock | INDOFORCETECH',
      }
    },
  ]
}